import { Request } from 'domain/shared/oneStop';
import OneStopRequest from 'domain/gpo/oneStop/List/OneStopRequest';
import { useListContext } from 'framework/list';
import useOneStopSettings from 'domain/gpo/oneStop/List/Settings/useOneStopSettings';
import { Fade } from 'framework/ui/mui-builder';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const OneStopListLayout = () => {
  const { areDescriptionsVisible } = useOneStopSettings();
  const { data: { items = [] } = {} } = useListContext();

  return (
    <Box
      sx={{
        flexGrow: 1,
        listStyle: 'none',
        padding: '18px 0',
        '@media (max-width: 991px)': {
          padding: '25px 50px',
        },
        '@media (max-width: 767px)': {
          padding: '25px',
        },
      }}
    >
      {items.length > 0 ? (
        items
          .filter(item => item && item.id)
          .map((item: Request) => (
            <OneStopRequest key={item.id} isDescriptionVisible={areDescriptionsVisible} {...item} />
          ))
      ) : (
        <Fade>
          <Typography variant="body1">There are no requests sent for the last 30 days.</Typography>
        </Fade>
      )}
    </Box>
  );
};

export default OneStopListLayout;
